// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"966":"css/admin-app.6756","7831":"css/app.6756"}[chunkId] + ".css";
};